import { render, staticRenderFns } from "./MaintenanceEnfermeria.vue?vue&type=template&id=3f2d9808"
import script from "./MaintenanceEnfermeria.vue?vue&type=script&lang=js"
export * from "./MaintenanceEnfermeria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports